var AdyenPaymentType;
(function(AdyenPaymentType) {
    AdyenPaymentType["Card"] = 'card';
    AdyenPaymentType["Bancontact"] = 'bcmc';
    AdyenPaymentType["BancontactMobile"] = 'bancontactMobile';
    AdyenPaymentType["Sepa"] = 'sepadirectdebit';
    AdyenPaymentType["Swish"] = 'swish';
})(AdyenPaymentType || (AdyenPaymentType = {}));

export { AdyenPaymentType };
//# sourceMappingURL=payment-type.js.map
